import React from "react";
import { Button } from "@components/Input";
import PropTypes from "prop-types";
import { CircularProgress } from "@material-ui/core";

import { showNotify } from "vendor/application/disptach";
import { createIntent } from "../../Tabs/Intents/application/utils/createIntent";
import { handleIntent } from "../../Tabs/Intents/application/utils/handleIntent";
import { saveIntent } from "../../Tabs/Intents/application/utils/saveIntent";

const FlowActionsButtons = ({
  t,
  isLoading,
  setLoading,
  currentNodes,
  dispatch,
  data,
  history,
  handleTabs,
  id,
  variables,
  handleAddVariables,
  handleAddEquivalences,
  intent,
  currentEdges,
}) => {
  const isEdit = id;
  const handleCreate = async () => {
    setLoading(true);

    const returnToList = () => {
      history.push(`/${data.actualProject.id}/nlp/build?tab=intents`);
      handleTabs?.();
    };

    const updatedIntent = {
      ...intent,
      nodes: currentNodes,
      edges: currentEdges,
    };
    try {
      await createIntent({
        intent: updatedIntent,
        variables: variables,
        access: data.access,
        actualProject: data.actualProject,
        user: data.user,
        device_id: data.device_id,
        handleAddVariables: handleAddVariables,
        handleAddEquivalences: handleAddEquivalences,
        dispatch: dispatch,
        props: { dispatch, data, history },
        returnToList,
      });
    } catch (error) {
      dispatch(
        showNotify({
          message: error?.message,
          severity: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = async () => {
    setLoading(true);
    try {
      await handleIntent({
        intent: {
          ...intent,
          nodes: currentNodes,
          edges: currentEdges,
        },
        variables: variables,
        access: data.access,
        dispatch,
        handleAddVariables,
        handleAddEquivalences,
        saveIntentFn: (sendIntent) =>
          saveIntent({
            sendIntent,
            actualProject: data.actualProject,
            access: data.access,
            dispatch,
          }),
        type: "edit",
      });
    } catch (error) {
      dispatch(
        showNotify({
          message: error?.message,
          severity: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="buttons_flow">
        <Button
          type="cancel"
          onClick={() => {
            history.push(`/${data.actualProject.id}/nlp/build?tab=intents`);
          }}
          text={t("common:intents.buttons.cancel")}
        />

        <Button
          type="primary"
          onClick={isEdit ? handleEdit : handleCreate}
          disabled={isLoading}
          text={
            isLoading ? (
              <CircularProgress size={21} />
            ) : isEdit ? (
              t("common:intents.buttons.save")
            ) : (
              t("common:intents.buttons.create")
            )
          }
        />
      </div>
    </>
  );
};

FlowActionsButtons.propTypes = {
  t: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  setLoading: PropTypes.func.isRequired,
  currentNodes: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  handleTabs: PropTypes.func,
  id: PropTypes.string,
  variables: PropTypes.array.isRequired,
  handleAddVariables: PropTypes.func.isRequired,
  handleAddEquivalences: PropTypes.func.isRequired,
  intent: PropTypes.object.isRequired,
  currentEdges: PropTypes.array.isRequired,
};

export default FlowActionsButtons;
